import { useMemo } from 'react';
import { RaffleStore, RaffleStoreProvider } from './RaffleStore';

export const RafflesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const store = useMemo(() => new RaffleStore(), []);

  return <RaffleStoreProvider store={store}>{children}</RaffleStoreProvider>;
};
